import React from 'react';
export class PrintOnlyImageSource extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPrinting: false,
        };
    }
    componentDidMount() {
        window.addEventListener('beforeprint', () => {
            this.setState({ isPrinting: true });
        });
        window.addEventListener('afterprint', () => {
            this.setState({ isPrinting: false });
        });
    }
    render() {
        return this.state.isPrinting ? React.createElement("source", Object.assign({}, this.props)) : null;
    }
}
//# sourceMappingURL=printOnlySource.js.map